
import template from './add_installation_dialog.html';

var AddInstallationViewModel = function(page)
{
	this.page = page;

	this.loading = ko.observable(false);
	this.installation_types = ko.observableArray(['development', 'qa', 'production']);
	this.installation_type = ko.observable();
	this.available_products = ko.observableArray();
	this.chosen_product = ko.observable();
	this.product_description = ko.observable();
	this.product_versions = ko.observableArray();
	this.product_features = ko.observableArray();
	this.available_accounts = ko.observableArray();
	this.chosen_account = ko.observable();
}

var AddInstallationClass = function(bindings)
{
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new AddInstallationViewModel(this);
	this.name = 'Add Installation';

	this.init = function() {
		this.get_available_accounts();
		self.get_available_products();
		self.viewModel.installation_type.subscribe((new_value)=>{
			self.viewModel.chosen_product(null);
			self.get_available_products();
		})

		//Product Drop Down Change Event
		self.viewModel.chosen_product.subscribe(function (value) {
			self.viewModel.product_description('');
			self.viewModel.product_versions([]);
			self.viewModel.product_features([]);
			// let value = $(this).val();
			if (value) {
				let filtered = self.viewModel.available_products().filter(function (n) {
					return n.product_id == value;
				});

				if (filtered && filtered[0]) {
					self.viewModel.product_description(filtered[0].description);

					if (Array.isArray(filtered[0].product_versions)){
						let installation_type = self.viewModel.installation_type();
						self.viewModel.product_versions(
							filtered[0].product_versions.filter((pv)=>{
								let installation_type_to_package_status_map = {
									'development': ['development', 'qa', 'production'],
									'qa': ['development', 'qa', 'production'],
									'production': ['production']
								}
								return installation_type_to_package_status_map[installation_type].includes(pv.package_status);
							})
						);

					}

					self.viewModel.product_features(filtered[0].product_features);
				}
			}
		});
	};

	this.get_available_accounts = () => {
		Grape.tables.select({schema: 'account', tablename: 'account'}, function(res) {
			if (res.status != 'OK')
			{
				Grape.alert_api_error(res);
				return;
			}

			self.viewModel.available_accounts(res.records);
		});
	}

	this.get_available_products = function(){
		$.getJSON('/available_products', {installation_type: self.viewModel.installation_type()}, function(res) {
			if (res.status != 'OK')
			{
				Grape.alert_api_error(res);
				return;
			}

			self.viewModel.available_products(res.list);
		});
	}

	this.add_installation = (install) => {
		this.viewModel.loading(true);
		let featureArray = new Array();
		$("#chkProductFeatures:checked").each(function(){
			console.log($(this).val());
			featureArray.push($(this).val());
		});


		var product_id = $('#ddlProduct').val();//self.viewModel.chosen_product();
		var installation_type = $('#ddlInstallationType').val()
		var product_version_id = $('#ddlProductVersions').val()
		let account_id = this.viewModel.chosen_account();
		var system_account_name = $('#txtSystemAccountName').val()
		var database_name  = $('#txtDatabase').val()
		var host = $('#txtHost').val()
		var port  = $('#txtPort').val()
		var fqdn  = $('#txtFQDN').val()


		$.postJSON('/psam/api/account/installation/save', {
			status: install ? 'Pending Install':'Pending Activation',
			account_id: account_id,
			product_id: product_id,
			installation_type: installation_type,
			product_version_id : product_version_id,
			features : featureArray,
			install_test_data : document.getElementById('chkInstallTestData').checked ,
			system_account_name : system_account_name,
			database_name : database_name,
			host : host,
			port : port,
			fqdn : fqdn}, function(res) {
			console.log('add installation and install')
		})
		.then( res => {
			this.viewModel.loading(false);
			if (res.status === 'ERROR') {
				Grape.alert_api_error(res);
				return;
			}

			if (install)
				this.activate(res.account_installation.installation_uuid);
			else
				this.close();
		})
		.catch( err => {
			this.viewModel.loading(false);
			Grape.alert_api_error(err);
		});
	};

	this.activate = (installation_uuid) => {
		this.viewModel.loading(true);
		$.postJSON('psam/api/account/installation/activate',
			{ installation_uuid: installation_uuid }
		)
		.then( res => {
			this.viewModel.loading(false);
			if (res.status === 'ERROR') {
				if (res.message === 'Installation already activated.') {
					Grape.alert({
						type: 'info',
						title: 'Account Activation',
						message: 'Account already activated, please login to manage your account.'
					});
					return;
				}

				Grape.alert_api_error(res);
			}

			this.monitor_installation(installation_uuid);
		});

	};

	this.monitor_installation = (installation_uuid) => {
		Grape.show_dialog(
			'ConfirmAccountDialog',
			{ installation_uuid: installation_uuid },
			{ onClose: ()=>{ this.close() }}
		);
	};

	this.option_checked = function(v,e) {
		alert(JSON.stringify(v));
	};

	this.onClose = function() {
	};

	this.btnclose = function() {
		self.close(false);
	};


}

//Register the dialog
export default {
	name: 'AddInstallation',
	dialog_class: AddInstallationClass,
	template: template
};
